import { Company } from '@domain/company';
import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

const getCompany = async ({ companyId, clubId }: { companyId?: string; clubId?: string }) => {
  const url = `${import.meta.env.VITE_MONOLITH_HOST}/v1/nightgraph/companies/${companyId}?clubId=${clubId}`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetCompany = ({
  companyId,
  clubId,
  options,
}: {
  companyId?: string;
  clubId?: string;
  options?: Record<string, boolean>;
}) => {
  return useGenericQuery<Company, RequestError>(
    ['company', companyId, clubId],
    () => getCompany({ companyId, clubId }),
    options
  );
};
